import { render } from "./DeleteConfirmModal.vue?vue&type=template&id=4e71f280&scoped=true"
import script from "./DeleteConfirmModal.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmModal.vue?vue&type=script&lang=js"

import "./DeleteConfirmModal.vue?vue&type=style&index=0&id=4e71f280&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e71f280"]])

export default __exports__